/**
 * CountDown Timer
 */

export default function TSCT_CountDown() {
	this.init = () => {
		// Do something
		jQuery(document).ready(function ($) {
			$(document).on("scroll", function () {
				if ($(".nami__countdown-timer.sticky").length) {
					if ($(this).scrollTop() >= 200) {
						$(".nami__countdown-timer.sticky").css("opacity", "1");
					} else {
						$(".nami__countdown-timer.sticky").css("opacity", "0");
					}
				}
			});

			if ($(".nami__countdown-timer").length) {
				$(".nami__countdown-timer").each(function () {
					const timer = $(this);
					const el = timer.find(".countdown__timer");
					const event_start_time = el.data("event_start_date");
					const event_end_time = el.data("event_end_date");
					const now = el.data("now");
					const currentTime = new Date(now);

					timer.slideUp();

					if (!event_start_time || !event_end_time) {
						return;
					}

					const countDownStartDate = new Date(event_start_time);
					const countDownEndDate = new Date(event_end_time);

					if (currentTime.getTime() - countDownStartDate.getTime() < 0) {
						return;
					}

					const offset = countDownEndDate.getTime() - currentTime.getTime();
					startCountDown(offset, timer);
				});
			}
		});
	};

	const startCountDown = (offset, el) => {
		if (offset <= 0) {
			return;
		}

		updateCountDown(offset, el);
		el.slideDown();

		const timer = setInterval(function () {
			updateCountDown(offset, el);
			offset -= 1000;
			if (offset < 0) {
				clearInterval(timer);
				timer.slideUp();
			}
		}, 1000);
	};

	const updateCountDown = (offset, el) => {
		// Time calculations for days, hours, minutes and seconds
		const days = Math.floor(offset / (1000 * 60 * 60 * 24));
		const hours = Math.floor(
			(offset % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
		);
		const minutes = Math.floor((offset % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((offset % (1000 * 60)) / 1000);
		// Output the result in an element with id="demo"
		el.find(".days").text((days < 10 ? "0" : "") + days);
		el.find(".hours").text((hours < 10 ? "0" : "") + hours);
		el.find(".minutes").text((minutes < 10 ? "0" : "") + minutes);
		el.find(".seconds").text((seconds < 10 ? "0" : "") + seconds);
	};
}
